export default __webpack_public_path__ + "006a64e24d3d0d7d85acfa774e8b567f.jpg";